import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT = gql `
  fragment MusiciansOnStageActivityFragment on MusiciansOnStageActivity {
    rounds {
      colorImage {
        image {
          ...AssetFragment
        }
      }
      monochromeImage {
        image {
          ...AssetFragment
        }
      }
      musicianAudio {
        audio {
          ...AssetFragment
        }
      }
      musicians {
        colorImage {
          image {
            ...AssetFragment
          }
        }
        id
        name
      }
      steps {
        answer
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT;
